package com.essntl.features.client.ui.allclients.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.utils.capitalizeFirstLetter
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem2
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ClientItem(
    client: ClientModel,
    isSelected: Boolean,
    showDivider: Boolean,
    onEditClient: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val interactionSource = remember { MutableInteractionSource() }

    val isHovered by interactionSource.collectIsHoveredAsState()

    val isPressed by interactionSource.collectIsPressedAsState()

    Column(
        modifier = modifier,
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .background(
                    when {
                        isSelected ->
                            MaterialTheme.esColorScheme.tintedPressed

                        isPressed ->
                            MaterialTheme.esColorScheme.tintedPressed

                        isHovered ->
                            MaterialTheme.esColorScheme.tintedHover

                        else ->
                            MaterialTheme.esColorScheme.bgSecondaryHover
                    },
                )
                .padding(
                    vertical = EsConstants.ListRowVerticalPadding,
                    horizontal = EsConstants.ListRowHorizontalPadding,
                )
                .height(EsConstants.ListRowItemHeight)
                .pointerHoverIcon(PointerIcon.Hand)
                .focusProperties { canFocus = false }
                .clickable(
                    interactionSource = interactionSource,
                    indication = null,
                    onClick = onEditClient,
                ),
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .weight(2f)
                    .fillMaxHeight(),
            ) {
                Column(
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.Start,
                ) {
                    Text(
                        text = client.prettyName.capitalizeFirstLetter(),
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.s2SemiBold16,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
            }

            // Email
            EsRowDefaultItem2(
                text = client.email?.ifEmpty { "-" } ?: "-",
            )

            // Telephone
            EsRowDefaultItem2(
                text = client.telephone?.ifEmpty { "-" } ?: "-",
            )
        }

        if (showDivider)
            HorizontalDivider(
                thickness = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
            )
    }
}